import { render, staticRenderFns } from "./bibliotecadigitala.vue?vue&type=template&id=842e818e&"
import script from "./bibliotecadigitala.vue?vue&type=script&lang=js&"
export * from "./bibliotecadigitala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports